define('models/list-state-rent',["exports", "underscore", "common", "models/list-state"], function (_exports, _underscore, _common, _listState) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _listState = _interopRequireDefault(_listState);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
  function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
  function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
  function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
  function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
  function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
  function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
  function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
  var DEFAULT_SORT = 'best';
  var _default = _exports.default = _listState.default.extend({
    initialize() {
      this.on('change', (m, options) => {
        if (!options.initial) {
          var props = (0, _underscore.chain)((0, _underscore.keys)(this.changed)).filter(key => key.includes('$') && key.indexOf('qty$') !== 0 && key.indexOf('dis$') !== 0).map(key => key.split('$')[0]).reduce((acc, key) => {
            acc[key] = true;
            return acc;
          }, {}).value();
          if ((0, _underscore.size)(props) > 0) {
            this.applyFilter(props);
          }
          if ('date' in this.changed || 'guests' in this.changed || 'budget' in this.changed || 'stars' in this.changed || 'amenities' in this.changed || 'neighborhood' in this.changed || 'bounds' in this.changed || 'bathrooms' in this.changed || 'bedrooms' in this.changed || 'currency' in this.changed || 'sort' in this.changed || 'type' in this.changed || 'hot' in this.changed || 'now' in this.changed) {
            this.location = null;
            this.trigger('state-change');
          }
          if ('amenities' in this.changed) {
            this.updateQuantity('amenities');
          }
          if ('type' in this.changed || 'hot' in this.changed) {
            this.updateQuantity('more');
          }
        }
      });
      this.on('change:currency change:date', this.updateBudgetLimits, this);
      this.on('change:p', () => {
        this.location = null;
      });
    },
    parseLocation() {
      var _query$get, _query$get2;
      var _location$pathname$sp = location.pathname.split('/'),
        _location$pathname$sp2 = _slicedToArray(_location$pathname$sp, 4),
        loc = _location$pathname$sp2[2],
        type = _location$pathname$sp2[3];
      var query = new URLSearchParams(location.search);
      var params = _objectSpread(_objectSpread({}, resolveLocation(loc)), resolveType(type));
      return _objectSpread(_objectSpread({}, (0, _common.parseBookParams)(query)), {}, {
        region: params.region,
        budget: (0, _common.parseRange)(query.get('budget')),
        stars: params.luxury ? [5] : (0, _common.parseIntegerArray)(query.get('stars')),
        amenities: (0, _common.parseArray)(query.get('amenities')),
        neighborhood: params.neighborhood ? [params.neighborhood] : (0, _common.parseArray)(query.get('neighborhood')),
        bounds: (0, _common.parseBounds)(query.get('bounds')),
        bedrooms: Number.isFinite(params.bedrooms) ? [params.bedrooms] : (0, _common.parseIntegerArray)(query.get('bedrooms')),
        bathrooms: (0, _common.parseInteger)(query.get('bathrooms')),
        type: params.type ? [params.type] : (0, _common.parseArray)(query.get('type')),
        hot: params.hot,
        now: query.has('now'),
        text: query.get('text') ? query.get('text').trim() : null,
        sort: (_query$get = query.get('sort')) !== null && _query$get !== void 0 ? _query$get : DEFAULT_SORT,
        p: Number((_query$get2 = query.get('p')) !== null && _query$get2 !== void 0 ? _query$get2 : 1),
        pf: query.has('pf')
      });
    },
    getLocation() {
      var _this$attributes$star, _this$attributes$amen, _this$attributes$neig, _this$attributes$bedr, _this$attributes$bath, _this$attributes$type;
      if (this.location) {
        return this.location;
      }
      var state = {
        date: this.attributes.date,
        guests: this.attributes.guests,
        currency: this.attributes.currency,
        region: this.attributes.region,
        budget: this.attributes.budget,
        stars: (_this$attributes$star = this.attributes.stars) !== null && _this$attributes$star !== void 0 ? _this$attributes$star : [],
        amenities: (_this$attributes$amen = this.attributes.amenities) !== null && _this$attributes$amen !== void 0 ? _this$attributes$amen : [],
        neighborhood: (_this$attributes$neig = this.attributes.neighborhood) !== null && _this$attributes$neig !== void 0 ? _this$attributes$neig : [],
        bounds: this.attributes.bounds,
        bedrooms: (_this$attributes$bedr = this.attributes.bedrooms) !== null && _this$attributes$bedr !== void 0 ? _this$attributes$bedr : [],
        bathrooms: (_this$attributes$bath = this.attributes.bathrooms) !== null && _this$attributes$bath !== void 0 ? _this$attributes$bath : [],
        type: (_this$attributes$type = this.attributes.type) !== null && _this$attributes$type !== void 0 ? _this$attributes$type : [],
        hot: this.attributes.hot,
        now: this.attributes.now,
        text: this.attributes.text,
        sort: this.attributes.sort,
        p: this.attributes.p,
        pf: this.attributes.pf
      };
      var loc = state.region;
      if (state.region === 'paris' && state.neighborhood.length === 1) {
        loc += `-${state.neighborhood[0]}`;
        state.neighborhood = [];
      }
      var type;
      if (state.type.length === 1) {
        type = state.type;
        state.type = [];
      } else if (state.stars.length === 1 && state.stars[0] === 5) {
        type = 'luxury';
        state.stars = [];
      } else if (state.hot) {
        type = 'hot-deals';
        delete state.hot;
      } else if (state.bedrooms.length === 1) {
        type = state.bedrooms[0] === 0 ? 'studio' : `${state.bedrooms[0]}-bedroom`;
        state.bedrooms = [];
      }
      var params = new URLSearchParams();
      if (state.date) {
        params.set('date', (0, _common.stringifyDateRange)(state.date));
      }
      if (state.guests > 1) {
        params.set('guests', state.guests);
      }
      if (state.budget) {
        params.set('budget', (0, _common.stringifyRange)(state.budget));
      }
      if (state.amenities.length > 0) {
        params.set('amenities', (0, _common.stringifyArray)(state.amenities));
      }
      if (state.bathrooms.length > 0) {
        params.set('bathrooms', (0, _common.stringifyArray)(state.bathrooms));
      }
      if (state.bedrooms.length > 0) {
        params.set('bedrooms', (0, _common.stringifyArray)(state.bedrooms));
      }
      if (state.stars.length > 0) {
        params.set('stars', (0, _common.stringifyArray)(state.stars));
      }
      if (state.neighborhood.length > 0) {
        params.set('neighborhood', (0, _common.stringifyArray)(state.neighborhood));
      }
      if (state.type.length > 0) {
        params.set('type', (0, _common.stringifyArray)(state.type));
      }
      if (state.bounds) {
        params.set('bounds', (0, _common.stringifyBounds)(state.bounds));
      }
      if (state.now) {
        params.set('now', '');
      }
      if (state.hot) {
        params.set('hot', '');
      }
      if (state.sort && state.sort !== DEFAULT_SORT) {
        params.set('sort', state.sort);
      }
      if (state.currency && state.currency !== GA.currencyDefault) {
        params.set('currency', state.currency);
      }
      if (state.text) {
        params.set('text', state.text);
      }
      if (state.p > 1) {
        params.set('p', state.p);
      }
      if (state.pf) {
        params.set('pf', '');
      }
      return this.location = {
        path: `/rent/${loc}${type ? `/${type}` : ''}`,
        params
      };
    },
    resetFilter() {
      var change = {
        amenities: null,
        bathrooms: null,
        bedrooms: null,
        now: null,
        more$now: null,
        hot: null,
        more$hot: null,
        budget: null,
        neighborhood: null,
        bounds: null,
        stars: null
      };
      for (var _i = 0, _Object$keys = Object.keys(this.attributes); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        if (key.match(/^(amenities|bathrooms|bedrooms|neighborhood|stars)_/)) {
          change[key] = false;
        }
      }
      this.set(change);
      this.backFilter();
    },
    applyFilter(props) {
      if (this.attributes.modal) {
        return;
      }
      var change = {};
      var budgetChanged = (!props || 'budget' in props) && !this.attributes.budget$delay;
      var starsChanged = !props || 'stars' in props;
      if (!props || 'amenities' in props) {
        this._groupBoolAttribute(change, 'amenities');
      }
      if (!props || 'bathrooms' in props) {
        this._groupBoolAttribute(change, 'bathrooms', Number);
      }
      if (!props || 'bedrooms' in props) {
        this._groupBoolAttribute(change, 'bedrooms', Number);
      }
      if (!props || 'type' in props) {
        this._groupBoolAttribute(change, 'type');
      }
      if (!props || 'more' in props) {
        change.now = this.attributes.more$now;
        change.hot = this.attributes.more$hot;
      }
      if (!props || 'sort' in props) {
        change.sort = this.attributes.sort$;
      }
      if (props && 'date' in props && !this.attributes.date$delay) {
        if (this.attributes.date$start) {
          var date = {
            start: this.attributes.date$start
          };
          if (this.attributes.date$end) {
            date.end = this.attributes.date$end;
          }
          change.date = date;
          starsChanged = false;
          change.stars = null;
          change.stars$1 = false;
          change.stars$2 = false;
          change.stars$3 = false;
          change.stars$4 = false;
          change.stars$5 = false;
          budgetChanged = true;
        } else {
          change.date = null;
        }
      }
      if (budgetChanged) {
        var budget = {};
        if (this.attributes.budget$start > 0) {
          budget.start = this.attributes.budget$start;
        }
        if (this.attributes.budget$end > 0 && this.attributes.budget$end < this.attributes._budget$max) {
          budget.end = this.attributes.budget$end;
        }
        if ((0, _underscore.size)(budget) > 0) {
          change.budget = budget;
        } else {
          change.budget = null;
        }
      }
      if (!props || 'neighborhood' in props) {
        this._groupBoolAttribute(change, 'neighborhood');
      }
      if (starsChanged) {
        this._groupBoolAttribute(change, 'stars', Number);
      }
      if ((0, _underscore.size)(change)) {
        this.set(change);
      }
    },
    backFilter(options) {
      var _budget$start, _budget$end;
      var _this$attributes = this.attributes,
        budget = _this$attributes.budget,
        date = _this$attributes.date,
        now = _this$attributes.now,
        hot = _this$attributes.hot,
        sort = _this$attributes.sort;
      var budgetLimits = this.budgetLimits(this.get('currency'));
      var change = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, this._ungroupBoolAttribute('amenities')), this._ungroupBoolAttribute('bathrooms', Number)), this._ungroupBoolAttribute('bedrooms', Number)), this._ungroupBoolAttribute('neighborhood')), this._ungroupBoolAttribute('stars', Number)), this._ungroupBoolAttribute('type')), {}, {
        more$now: now,
        more$hot: hot
      }, budgetLimits), {}, {
        budget$start: (_budget$start = budget === null || budget === void 0 ? void 0 : budget.start) !== null && _budget$start !== void 0 ? _budget$start : 0,
        budget$end: (_budget$end = budget === null || budget === void 0 ? void 0 : budget.end) !== null && _budget$end !== void 0 ? _budget$end : budgetLimits._budget$max,
        date$start: date === null || date === void 0 ? void 0 : date.start,
        date$end: date === null || date === void 0 ? void 0 : date.end,
        sort$: sort
      });
      this.set(change, options);
    },
    budgetLimits(currency) {
      switch (currency) {
        case 'EUR':
        case 'GBP':
        case 'USD':
          return {
            '_budget$max': 10000,
            '_budget$step': 100
          };
        case 'RUB':
          return {
            '_budget$max': 1000000,
            '_budget$step': 10000
          };
        default:
          return undefined;
      }
    },
    neigh() {
      var _this$attributes2 = this.attributes,
        bounds = _this$attributes2.bounds,
        neighborhood = _this$attributes2.neighborhood;
      return !(0, _underscore.isEmpty)(neighborhood) || bounds;
    },
    more() {
      var _this$attributes3 = this.attributes,
        bathrooms = _this$attributes3.bathrooms,
        bedrooms = _this$attributes3.bedrooms,
        type$loft = _this$attributes3.type$loft,
        type$yacht = _this$attributes3.type$yacht,
        hot = _this$attributes3.hot,
        now = _this$attributes3.now;
      return !(0, _underscore.isEmpty)(bathrooms) || !(0, _underscore.isEmpty)(bedrooms) || type$loft || type$yacht || hot || now;
    },
    getStatPath() {
      return `/rent-stat`;
    }
  });
  function resolveLocation(alias) {
    if (alias === 'paris' || alias === 'cote') {
      return {
        region: alias
      };
    }
    if (alias === 'france') {
      return {
        region: 'other'
      };
    }
    if (alias.startsWith('paris-')) {
      return {
        region: 'paris',
        neighborhood: alias.substring('paris-'.length)
      };
    }
    return {
      postal: alias
    };
  }
  function resolveType(alias) {
    if (alias === undefined) {
      return undefined;
    }
    if (alias === 'studio') {
      return {
        bedrooms: 0
      };
    }
    var bedroomsMatch = alias.match(/^([1-9])-bedroom$/);
    if (bedroomsMatch) {
      return {
        bedrooms: Number(bedroomsMatch[1])
      };
    }
    if (alias === 'luxury') {
      return {
        luxury: true
      };
    }
    if (alias === 'hot-deals') {
      return {
        hot: true
      };
    }
    return {
      type: alias
    };
  }
});//# sourceMappingURL=list-state-rent.js.map
;
